import { Bike, CheckCircle, ChefHat, Package, Send, Store, Timer } from "lucide-react";

// Etapas e textos do acompanhamento do pedido no cardápio (repaginado em
// 23/10/2026: o status virou o primeiro card, com bolinhas).

export const FINALIZADOS = ["concluido", "entregue", "retirado"];

export const hora = (iso) => {
  if (!iso) return null;
  try { return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }); } catch { return null; }
};

export const reais = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

/** As bolinhas: retirada tem 4, entrega tem 5 (com "A caminho"). */
export function bolinhas(pedido, retirada) {
  const base = [
    { id: "recebido", rotulo: "Recebido", icone: Send, hora: hora(pedido?.created_at) },
    { id: "producao", rotulo: "Preparo", icone: ChefHat, hora: hora(pedido?.ts_producao) },
    { id: "pronto", rotulo: "Pronto", icone: Package, hora: hora(pedido?.ts_pronto) },
  ];
  if (!retirada) base.push({ id: "em_rota", rotulo: "A caminho", icone: Bike, hora: hora(pedido?.ts_em_rota) });
  base.push({ id: "fim", rotulo: retirada ? "Retirado" : "Entregue", icone: CheckCircle, hora: hora(pedido?.ts_concluido) });
  return base;
}

/** Posição atual nas bolinhas (o tamanho da lista = tudo feito). */
export function posicao(pedido, retirada, total) {
  const st = pedido?.status;
  if (FINALIZADOS.includes(st)) return total;
  const mapa = { aguardando_aceite: 0, agendado: 0, aceito: 1, producao: 1, pronto: 2, na_bag: 2, em_rota: retirada ? 2 : 3 };
  return mapa[st] ?? 0;
}

/** Título, frase e cor da etapa atual. */
export function etapaAtual(pedido, retirada, { previsao } = {}) {
  const st = pedido?.status;
  if (FINALIZADOS.includes(st)) {
    return retirada
      ? { titulo: "Pedido retirado! 🎉", frase: "Bom apetite!", cor: "green", icone: CheckCircle }
      : { titulo: "Pedido entregue! 🎉", frase: "Esperamos que goste. Bom apetite!", cor: "green", icone: CheckCircle };
  }
  const p = previsao ? ` Fica pronto por volta de ${previsao}.` : "";
  const tabela = {
    aguardando_aceite: { titulo: "Aguardando o restaurante", frase: "Seu pedido chegou e será confirmado em instantes.", cor: "orange", icone: Send },
    aceito: { titulo: "Pedido aceito!", frase: `O restaurante já está se organizando.${p}`, cor: "green", icone: CheckCircle },
    producao: { titulo: "Preparando seu pedido", frase: `Está no fogo!${p}`, cor: "orange", icone: ChefHat },
    pronto: retirada
      ? { titulo: "Pronto para retirar! 🎉", frase: "Pode vir buscar quando quiser.", cor: "green", icone: Store }
      : { titulo: "Procurando entregador", frase: "Seu pedido está pronto e já vai sair.", cor: "blue", icone: Timer },
    na_bag: { titulo: "Saiu para entrega!", frase: "O entregador acabou de pegar seu pedido.", cor: "purple", icone: Package },
    em_rota: { titulo: "A caminho!", frase: "Fica de olho na porta.", cor: "blue", icone: Bike },
  };
  return tabela[st] || tabela.aguardando_aceite;
}

export const CORES = {
  orange: { icone: "bg-orange-500", texto: "text-orange-500", anel: "ring-orange-500/30", faixa: "from-orange-500/15" },
  green: { icone: "bg-emerald-500", texto: "text-emerald-500", anel: "ring-emerald-500/30", faixa: "from-emerald-500/15" },
  blue: { icone: "bg-blue-500", texto: "text-blue-500", anel: "ring-blue-500/30", faixa: "from-blue-500/15" },
  purple: { icone: "bg-violet-500", texto: "text-violet-500", anel: "ring-violet-500/30", faixa: "from-violet-500/15" },
  indigo: { icone: "bg-indigo-500", texto: "text-indigo-500", anel: "ring-indigo-500/30", faixa: "from-indigo-500/15" },
  red: { icone: "bg-red-500", texto: "text-red-500", anel: "ring-red-500/30", faixa: "from-red-500/15" },
};

/** "Hoje · 20:00–20:30" — a janela do pedido agendado (+30 min), como em Meus Pedidos. */
export function janelaAgendada(iso) {
  if (!iso) return "";
  try {
    const [d, hm] = String(iso).split("T");
    const [y, mo, da] = d.split("-").map((n) => parseInt(n, 10));
    const [hh, mm] = (hm || "00:00").split(":");
    const dt = new Date(y, mo - 1, da);
    const agora = new Date();
    const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
    const diff = Math.round((dt - hoje) / 86400000);
    const dia = diff === 0 ? "Hoje" : diff === 1 ? "Amanhã" : dt.toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "long" });
    const fim = parseInt(hh, 10) * 60 + parseInt(mm, 10) + 30;
    return `${dia} · ${hh}:${mm}–${String(Math.floor(fim / 60) % 24).padStart(2, "0")}:${String(fim % 60).padStart(2, "0")}`;
  } catch {
    return iso;
  }
}
